import type React from 'react';
import { BORDERS, SPACING } from '../../../../constants/design';
import { useColors } from '../../../../contexts/ThemeContext';
import { COLOR_PALETTES } from '../../../../utils/colorUtils';

interface ColorSchemePreviewProps {
  color: string;
  size?: number;
}

export const ColorSchemePreview: React.FC<ColorSchemePreviewProps> = ({ color, size = 48 }) => {
  const tokens = useColors();
  const palette = COLOR_PALETTES[color as keyof typeof COLOR_PALETTES];
  const colorValue = palette?.[500] || color;

  return (
    <div
      style={{
        width: `${size}px`,
        height: `${size}px`,
        minWidth: `${size}px`,
        minHeight: `${size}px`,
        padding: SPACING.xs,
        border: `${BORDERS.width.thin} solid ${tokens.border.primary}`,
        borderRadius: BORDERS.radius.sm,
        background: tokens.surface.container,
        display: 'flex',
        flexDirection: 'column',
        gap: '2px',
        boxSizing: 'border-box',
        flexShrink: 0,
      }}
    >
      <div
        style={{
          width: '100%',
          height: '40%',
          background: colorValue,
          borderRadius: '2px',
          minHeight: '8px',
        }}
      />
      <div
        style={{
          width: '100%',
          height: '25%',
          background: palette?.[100] || colorValue,
          borderRadius: '2px',
          opacity: 0.4,
          minHeight: '5px',
        }}
      />
      <div
        style={{
          width: '60%',
          height: '15%',
          background: palette?.[300] || colorValue,
          borderRadius: '2px',
          opacity: 0.6,
          minHeight: '3px',
        }}
      />
    </div>
  );
};
